export const SURVEY_TYPES = {
  HABITS: '1a6e2ced-d9fc-422d-92ad-2952374cecbe',
  GOALS: 'e478899a-9b82-4d88-8b26-061d1b0ff26a',
};
